class FormErrorTxtControl {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    $('.wpcf7-form-control').closest('.c-more-btn').click(function() {
      $('.wpcf7-not-valid-tip').css({'display': 'block'});
      let timeOut = setInterval(() => {
        if($('.wpcf7-not-valid-tip').length) {
          $('.wpcf7-not-valid-tip').css({'display': 'block'});
          clearInterval(timeOut);
        }
      }, 100);
    })
  }
}